/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Not_AssignedInputs */

const th_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้ตัดสินคนนี้ไม่ได้รับมอบหมายเกมนี้`)
};

const en_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That referee is not on this game.`)
};

const ja_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この審判はこの試合に割り当てられていません。`)
};

const zh_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该裁判未被指派到这场比赛。`)
};

const es_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese árbitro no está en este partido.`)
};

const pt_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse árbitro não está neste jogo.`)
};

const id_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wasit itu tidak ditugaskan untuk pertandingan ini.`)
};

const fr_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet arbitre n’est pas sur ce match.`)
};

const tl_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi nakatalaga sa larong ito ang referee na iyon.`)
};

const vi_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trọng tài đó không được phân cho trận này.`)
};

const ko_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그 심판은 이 경기에 배정되지 않았습니다.`)
};

const de_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Schiedsrichter ist nicht für dieses Spiel angesetzt.`)
};

const ru_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот судья не назначен на данный матч.`)
};

const tr_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O hakem bu maça atanmadı.`)
};

const it_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quell'arbitro non è assegnato a questa partita.`)
};

const pl_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten sędzia nie jest wyznaczony do tego meczu.`)
};

const uk_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цього суддю не призначено на цей матч.`)
};

const hi_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह रेफ़री इस मैच के लिए नियुक्त नहीं है।`)
};

const ar_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ذلك الحكم غير معيَّن لهذه المباراة.`)
};

const ms_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengadil itu tidak ditugaskan untuk perlawanan ini.`)
};

const bn_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওই রেফারি এই খেলার জন্য নিযুক্ত নন।`)
};

const zh_tw2_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`那位裁判未被指派到這場比賽。`)
};

const zh_hk2_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`那位裁判未被指派到這場比賽。`)
};

const ur_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وہ ریفری اس میچ کے لیے مقرر نہیں۔`)
};

const fa_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آن داور برای این بازی تعیین نشده است.`)
};

const sw_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refa huyo hajapangwa kwenye mchezo huu.`)
};

const nl_err_not_assigned = /** @type {(inputs: Err_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die scheidsrechter is niet aangewezen voor deze wedstrijd.`)
};

/**
* | output |
* | --- |
* | "That referee is not on this game." |
*
* @param {Err_Not_AssignedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_not_assigned = /** @type {((inputs?: Err_Not_AssignedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Not_AssignedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_not_assigned(inputs)
	if (locale === "ja") return ja_err_not_assigned(inputs)
	if (locale === "zh") return zh_err_not_assigned(inputs)
	if (locale === "es") return es_err_not_assigned(inputs)
	if (locale === "pt") return pt_err_not_assigned(inputs)
	if (locale === "id") return id_err_not_assigned(inputs)
	if (locale === "fr") return fr_err_not_assigned(inputs)
	if (locale === "tl") return tl_err_not_assigned(inputs)
	if (locale === "vi") return vi_err_not_assigned(inputs)
	if (locale === "ko") return ko_err_not_assigned(inputs)
	if (locale === "de") return de_err_not_assigned(inputs)
	if (locale === "ru") return ru_err_not_assigned(inputs)
	if (locale === "tr") return tr_err_not_assigned(inputs)
	if (locale === "it") return it_err_not_assigned(inputs)
	if (locale === "pl") return pl_err_not_assigned(inputs)
	if (locale === "uk") return uk_err_not_assigned(inputs)
	if (locale === "hi") return hi_err_not_assigned(inputs)
	if (locale === "ar") return ar_err_not_assigned(inputs)
	if (locale === "ms") return ms_err_not_assigned(inputs)
	if (locale === "bn") return bn_err_not_assigned(inputs)
	if (locale === "zh-TW") return zh_tw2_err_not_assigned(inputs)
	if (locale === "zh-HK") return zh_hk2_err_not_assigned(inputs)
	if (locale === "ur") return ur_err_not_assigned(inputs)
	if (locale === "fa") return fa_err_not_assigned(inputs)
	if (locale === "sw") return sw_err_not_assigned(inputs)
	if (locale === "nl") return nl_err_not_assigned(inputs)
	return en_err_not_assigned(inputs)
});